import React from "react";
import Components from "mpm-components";
import Services from "mpm-services";
import { FormattedMessage } from "react-intl";
import {
  Form,
  Button,
  Icon,
  Divider,
} from "semantic-ui-react";
import { DateInput } from "semantic-ui-calendar-react";
import Utilities from "mpm-config/Utilities";
import MPMContext from "mpm-config/context/MPMContext";
import { AcquereurCP } from "mpm-classes/CessionProduit";
export default ({ cessionProduit, onChangeCessionProduit, setMessage, editMode }) => {

  
  const [acquereur, setAcquereur] = React.useState( cessionProduit.entreposage ? cessionProduit.entrepotCPDTO :cessionProduit.acquereurCPDTO);
  const [loading, setLoading] = React.useState(false);

  const onSearchAcequereur = () => {
    if (acquereur.numeroAcquereur && acquereur.numeroAcquereur !== "") {
      setLoading(true);
      Services.CessionsProduitDataService.searchAcquereur(
        acquereur, cessionProduit.entreposage
      ).then((result) => {
        if (result.success) {
          setAcquereur({
            ...result,
            numeroAcquereur: acquereur.numeroAcquereur,
          });
          setMessage({
            success: true,
            header: "Recherche Acquereur",
            content: "Opération effectuée avec succèes",
          });

          setLoading(false);
          onChangeCessionProduit({
            ...cessionProduit,
            typeAcquereur: result.typeAcquereur,
            acquereurCPDTO: result,
            entrepotCPDTO : cessionProduit.entreposage ? result : null
          });
        } else {
          setMessage({
            error: true,
            header: "Recherche Acquereur",
            content: `L'acquereur avec login ${acquereur.numeroAcquereur}, non trouvée`,
          });
          setAcquereur({
            ...result,
            numeroAcquereur: "",
            typeAcquereur: "",
            raisonSocialeFR: "",
            nom: "",
            prenom: ""
          });
          onChangeCessionProduit({
            ...cessionProduit,
            typeAcquereur: "",
            acquereurCPDTO: new AcquereurCP(),
          });
          setLoading(false);
        }
      }).catch(error => {
        setMessage({
          error: true,
          header: "Recherche Acquereur",
          content: `Une erreur est survenue lors de la recherche de l'acquereur`,
        });
        setLoading(false);
      });
    }
  };

  const onChangeForData = (name, value) => {
    onChangeCessionProduit({
      ...cessionProduit,
      [name]: value,
    });
  };

  const onChangeAcquereur = (name, value) => {
    let data = {
      ...acquereur,
      [name]: value,
    };
    setAcquereur({ ...data });
    // onChangeCessionProduit({
    //   ...cessionProduit,
    //   acquereurCPDTO: data,
    // });
  };
  const onToggleEntrpot = () => {
    setAcquereur( new AcquereurCP());
    onChangeCessionProduit({
      ...cessionProduit,
      acquereurCPDTO: new AcquereurCP(),
      entreposage: !cessionProduit.entreposage
    });
  }
  return (
    <MPMContext.Consumer>
      {(context) => <Components.Regions.RegionWithHeader
      title="menu.cession.product"
      headerColor="blue"
      headerSize="small"
    >
      <Form>
        <Form.Group widths="equal">
          <Form.Input
            width="15"
            label="Numéro Cession "
            disabled
            value={cessionProduit.numeroCessionComplet}
          />

          <DateInput
            label="Date Système"
            type="text"
            name="dateSysteme"
            icon="calendar"
            disabled
            iconPosition="right"
            value={cessionProduit.dateSysteme}
            animation="fade"
            autoComplete="off"
            dateFormat="DD/MM/YYYY"
            onChange={(e, { name, value }) => {}}
          />

          <DateInput
            label={
              <label>
                Date Cession <font color="red">*</font>
              </label>
            }
            clearable
            closable
            type="text"
            name="dateCession"
            icon="calendar"
            iconPosition="right" 
            value={cessionProduit.dateCession}
            maxDate={new Date()}
            animation="fade"
            autoComplete="off"
            dateFormat="DD/MM/YYYY"
            onChange={(e, { name, value }) => onChangeForData(name, value)}
          />
        </Form.Group>
        <Divider />
        <Form.Checkbox toggle
            onChange={(e, { name, value }) =>
              onToggleEntrpot()
            }
          checked={cessionProduit.entreposage}  label="Choisir Entreposage"/>
        <Form.Group widths="equal" >
          <Form.Select
            label={ <FormattedMessage tagName="label" id="label.table.type-acquereur" />
            }
            options={Utilities.getTypeAcquereurCPDropDownOptions(cessionProduit.entreposage)}
            required
            onChange={(e, { name, value }) =>
              onChangeAcquereur("typeAcquereur", value)
            }
            value={acquereur.typeAcquereur}
          />
           <Form.Input
              label={`${cessionProduit.entreposage ? "Login Entrepôt" : "Numéro Acquéreur"}`}
              required
              onChange={(event) =>
                onChangeAcquereur("numeroAcquereur", event.target.value)
              }
              value={acquereur.numeroAcquereur}
              action={
                <Button
                  loading={loading}
                  disabled={!acquereur.numeroAcquereur || !acquereur.typeAcquereur}
                  positive
                  icon
                  onClick={() => onSearchAcequereur()}
                >
                  <Icon name="search" />
                </Button>
              }
            />
            <Form.Field />
        </Form.Group>

        <Form.Group widths="equal">
           
            <Form.Input
              label={`${cessionProduit.entreposage ? "Prénom Entrepôt" : "Prénom Acquéreur"}`}
              value={acquereur.prenom}
              disabled
            />

            <Form.Input
              label={`${cessionProduit.entreposage ? "Nom Entrepôt" : "Nom Acquéreur"}`}
              value={acquereur.nom}
              disabled
            />
            <Form.Input
              label={`${cessionProduit.entreposage ? "Raison Sociale Entrepôt" : "Raison Sociale Acquéreur"}`}
              disabled
              value={acquereur.raisonSocialeFR}
            />
          </Form.Group>
        
      </Form>
    </Components.Regions.RegionWithHeader>}
    </MPMContext.Consumer>
    
  );
};
